const interactiveEl = document.querySelector(
  '[data-works-with-integration-features-interactive]'
);
const sliders =
  interactiveEl?.querySelectorAll(
    '[data-works-with-integration-features-slider]'
  ) || [];
const slideEls = interactiveEl?.querySelectorAll('[data-slide]') || [];
const countSlideVariants = slideEls.length / sliders.length;
const slideDelay = 4000;
const startingIndex = 1;
let currentIndex = 1;

const activateSlide = (slideIndex) => {
  slideEls.forEach((activeSlideEl) => {
    activeSlideEl.setAttribute('data-active', 'false');
  });

  const selectedSlideEls =
    interactiveEl?.querySelectorAll(`[data-slide="${slideIndex}"]`) || [];

  selectedSlideEls.forEach((selectedSlideEl) => {
    selectedSlideEl.setAttribute('data-active', 'true');
  });
};

let sliderInterval = setTimeout(function initSliderAutoplay() {
  if (interactiveEl) {
    activateSlide(currentIndex);

    if (currentIndex === countSlideVariants) {
      currentIndex = startingIndex;
    } else {
      currentIndex += 1;
    }

    sliderInterval = setTimeout(initSliderAutoplay, slideDelay);
  }
}, 0);

export const initActivateSlideBtns = () => {
  if (interactiveEl) {
    const controlEls =
      document.querySelectorAll(
        '[data-works-with-integrations-content-features-control]'
      ) || [];

    controlEls.forEach((controlEl) => {
      const slideIndex = controlEl.getAttribute('data-slide');

      controlEl.addEventListener('click', () => {
        activateSlide(slideIndex);
        clearInterval(sliderInterval);
      });
    });
  }
};
